// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: null,
      stateByName: {}
    },
    {
      id: 'c56a8d43-8411-41bc-b0b6-b0149cc30e0a',
      type: 'Sprite',
      runtimeType: null,
      name: 'flame',
      className: '',
      x: 0,
      y: 14,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Flame',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    },
    {
      id: '124ada2a-af1b-40d0-9977-7c05f0138d41',
      type: 'Sprite',
      runtimeType: null,
      name: 'rocket',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Rocket_Rocket',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {}
    }
  ],
  version: '1.0.0',
  stateNames: [
    'doors-closed',
    'doors-opened'
  ],
  animations: []
} as const;

export class RocketBlockerRocketLayout {
  static raw = raw;
  root: Container;
  flame: Sprite;
  rocket: Sprite;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: 'doors-closed' | 'doors-opened';
    ModelByName: {
      root: typeof raw['list'][0];
      flame: typeof raw['list'][1];
      rocket: typeof raw['list'][2];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
